import actions from "./actions";

const initialState = {
  detail: {},
  loading: false,
  credentials: {},
  error: false,
};

export default function credentialReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
